import React from 'react'
import Link from 'gatsby-link'
import iconArrow from '../../images/svg/arrow-right.svg'
import { FormattedMessage } from 'react-intl'
import './style.sass'

const Menu = ({ onLinkClick, locale }) => {
  const linkPrefix = locale === 'it' ? '' : '/en'
  const otherLanguage = locale === 'it' ? '/en' : '/'

  return (
    <div className="Menu">
      <div className="wrap">
        <div className="Menu__Row">
          <div className="Menu__Column Menu__Column--left">
            <Link to={`${linkPrefix}/`} onClick={onLinkClick}>
              <h1 className="text-bold">
                <FormattedMessage id="menu.heading.firstLine" />
                <br />
                <FormattedMessage id="menu.heading.secondLine" />
              </h1>
            </Link>
          </div>
          <div className="Menu__Column Menu__Column--right">
            <Link
              to={`${linkPrefix}/`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              Home Page
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/progetto`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.progetto" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/eventi`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.eventi" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/pubblicazioni`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.pubblicazioni" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/mappe`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.mappe" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/interviste`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.interviste" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/relazioni-e-conferenze`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.relazioniEConferenze" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/gruppo-di-ricerca`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.gruppoDiRicerca" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>
            <Link
              to={`${linkPrefix}/contatti`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              <FormattedMessage id="menu.contatti" />
              <img src={iconArrow} alt="Arrow icon" />
            </Link>

            <a
              href={`${otherLanguage}`}
              className="Menu__Link"
              onClick={onLinkClick}
            >
              {locale === 'it' && <span>English</span>}
              {locale === 'en' && <span>Italiano</span>}
              <img src={iconArrow} alt="Arrow icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/menu/index.js